<template lang="pug">
div
  v-row.monitoragroweb-row
    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Uso por funcionalidade
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitoragroweb-action-button",
            @click="dialogs.usoFuncionalidade = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="usoFuncionalidadeSeries.length",
            :key="`uso-card-${renderKey}`",
            type="bar",
            :options="usoFuncionalidadeChartOptions",
            :series="usoFuncionalidadeSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Usuários e Clientes ativos por dia
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitoragroweb-action-button",
            @click="dialogs.ativosPorDia = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="ativosPorDiaSeries.length",
            :key="`ativos-card-${renderKey}`",
            type="line",
            :options="ativosPorDiaChartOptions",
            :series="ativosPorDiaSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

  v-row.monitoragroweb-row
    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Alcance por funcionalidade
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitoragroweb-action-button",
            @click="dialogs.alcance = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="alcanceSeries.length",
            :key="`alcance-card-${renderKey}`",
            type="bar",
            :options="alcanceChartOptions",
            :series="alcanceSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Funcionalidades menos utilizadas
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitoragroweb-action-button",
            @click="dialogs.menosUtilizadas = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="menosUtilizadasSeries.length",
            :key="`menos-card-${renderKey}`",
            type="bar",
            :options="menosUtilizadasChartOptions",
            :series="menosUtilizadasSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.usoFuncionalidade",
    @input="dialogs.usoFuncionalidade = $event",
    content-class="monitoragroweb-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Uso por funcionalidade
        v-btn(icon, @click="dialogs.usoFuncionalidade = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll.panel-card__dialog-content--chart
        .panel-card__chart-canvas(
          v-if="usoFuncionalidadeDialogSeries.length",
          :style="{ minWidth: `${usoFuncionalidadeDialogWidth}px` }"
        )
          apexchart(
            :key="`uso-dialog-${renderKey}`",
            type="bar",
            :options="usoFuncionalidadeDialogOptions",
            :series="usoFuncionalidadeDialogSeries",
            width="100%",
            height="520"
          )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.ativosPorDia",
    @input="dialogs.ativosPorDia = $event",
    content-class="monitoragroweb-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Usuários e Clientes ativos por dia
        v-btn(icon, @click="dialogs.ativosPorDia = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="ativosPorDiaSeries.length",
          :key="`ativos-dialog-${renderKey}`",
          type="line",
          :options="ativosPorDiaDialogOptions",
          :series="ativosPorDiaSeries",
          height="520"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.alcance",
    @input="dialogs.alcance = $event",
    content-class="monitoragroweb-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Alcance por funcionalidade
        v-btn(icon, @click="dialogs.alcance = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="alcanceDialogSeries.length",
          :key="`alcance-dialog-${renderKey}`",
          type="bar",
          :options="alcanceDialogOptions",
          :series="alcanceDialogSeries",
          :height="rankingDialogHeight(alcanceItems)"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.menosUtilizadas",
    @input="dialogs.menosUtilizadas = $event",
    content-class="monitoragroweb-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Funcionalidades menos utilizadas
        v-btn(icon, @click="dialogs.menosUtilizadas = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="menosUtilizadasDialogSeries.length",
          :key="`menos-dialog-${renderKey}`",
          type="bar",
          :options="menosUtilizadasDialogOptions",
          :series="menosUtilizadasDialogSeries",
          :height="rankingDialogHeight(menosUtilizadasItems)"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  clientes-funcionalidade-dialog(
    v-model="clienteDialog.aberto",
    :item-label="clienteDialog.funcionalidade",
    :body="clientesDialogBody"
  )
</template>

<script>
import ClientesFuncionalidadeDialog from "@/components/dashboards/monitoragroweb/ClientesFuncionalidadeDialog";
import { CARACTERIZACAO_SLUGS } from "@/utils/caracterizacao";

const CHART_COLORS = {
  clientes: "#1d6a5e",
  usuarios: "#2f6fd0",
  acessos: "#469b68",
  acoes: "#6ba3e8",
  tempo: "#5f6b7a",
  tendencia: "#ff6b6b"
};

const USO_COLORS = {
  acessosTela: CHART_COLORS.acessos,
  acoesRealizadas: CHART_COLORS.acoes,
  tempoUso: CHART_COLORS.tempo,
  usuariosDistintos: CHART_COLORS.usuarios
};

const ATIVOS_COLORS = {
  clientesAtivos: CHART_COLORS.clientes,
  tendencia: CHART_COLORS.tendencia,
  usuariosAtivos: CHART_COLORS.usuarios
};

const ALCANCE_COLORS = {
  clientesDistintos: CHART_COLORS.clientes,
  usuariosDistintos: CHART_COLORS.usuarios
};

const MENOS_UTILIZADAS_COLORS = {
  acessosTela: CHART_COLORS.acessos,
  tempoTela: CHART_COLORS.tempo
};

const INITIAL_RANKING_LIMIT = 10;
const RANKING_DIALOG_MIN_HEIGHT = 520;
const RANKING_DIALOG_BAR_HEIGHT = 44;
const INITIAL_USO_LIMIT = 10;
const USO_DIALOG_MIN_WIDTH = 1100;
const USO_DIALOG_ITEM_WIDTH = 140;
const NUMBER_FORMATTER = new Intl.NumberFormat("pt-BR");
const USO_SERIES_OCULTAS = ["Ações realizadas", "Tempo de uso (min)"];

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function formatInteger(value) {
  return NUMBER_FORMATTER.format(Math.round(toNumber(value)));
}

function sortByTotalDesc(items, metricKeys) {
  const total = item => metricKeys.reduce((soma, key) => soma + toNumber(item[key]), 0);
  return toArray(items)
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const diff = total(b.item) - total(a.item);
      if (diff !== 0) return diff;
      return a.index - b.index;
    })
    .map(entry => entry.item);
}

function sortByTotalAsc(items, metricKeys) {
  const total = item => metricKeys.reduce((soma, key) => soma + toNumber(item[key]), 0);
  return toArray(items)
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const diff = total(a.item) - total(b.item);
      if (diff !== 0) return diff;
      return a.index - b.index;
    })
    .map(entry => entry.item);
}

function comTendenciaLinear(items, campo) {
  const dados = toArray(items);
  const n = dados.length;
  if (!n) return [];

  const valor = item => toNumber(item[campo]);

  const sumX = dados.reduce((soma, _, index) => soma + index, 0);
  const sumY = dados.reduce((soma, item) => soma + valor(item), 0);
  const sumXY = dados.reduce((soma, item, index) => soma + index * valor(item), 0);
  const sumX2 = dados.reduce((soma, _, index) => soma + index * index, 0);

  const denominador = n * sumX2 - sumX * sumX;
  if (!denominador) {
    const media = sumY / n;
    return dados.map(item => ({ ...item, tendencia: media }));
  }

  const b = (n * sumXY - sumX * sumY) / denominador;
  const a = (sumY - b * sumX) / n;

  return dados.map((item, index) => ({
    ...item,
    tendencia: Math.max(0, a + b * index)
  }));
}

function formatTimestampBR(value) {
  if (value === null || value === undefined || value === "") return "";

  const raw =
    typeof value === "number"
      ? value
      : typeof value === "string" && /^\d+$/.test(value)
      ? Number(value)
      : value;

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return "";

  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const year = parsed.getFullYear();
  return `${day}/${month}/${year}`;
}

function createUsoFuncionalidadeOptions(chartHeight, categories) {
  return {
    chart: {
      type: "bar",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false },
      stacked: false,
      events: {
        mounted: chartContext => {
          USO_SERIES_OCULTAS.forEach(nome => chartContext.hideSeries(nome));
        }
      }
    },
    colors: [
      USO_COLORS.usuariosDistintos,
      USO_COLORS.acessosTela,
      USO_COLORS.acoesRealizadas,
      USO_COLORS.tempoUso
    ],
    stroke: { width: 0 },
    plotOptions: {
      bar: { borderRadius: 3, columnWidth: "72%" }
    },
    dataLabels: { enabled: false },
    grid: { borderColor: "#dfe7f5", strokeDashArray: 4 },
    legend: { show: true, position: "top", horizontalAlign: "center" },
    xaxis: {
      categories,
      labels: {
        rotate: -20,
        hideOverlappingLabels: false,
        trim: false,
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      tickAmount: 6,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: value => formatInteger(value) }
    }
  };
}

function createUsoFuncionalidadeSeries(items) {
  const normalizedItems = toArray(items);
  if (!normalizedItems.length) return [];

  const pluck = key => normalizedItems.map(item => toNumber(item[key]));
  const series = [
    { name: "Usuários", data: pluck("usuariosDistintos") },
    { name: "Acessos", data: pluck("acessosTela") },
    { name: "Ações realizadas", data: pluck("acoesRealizadas") },
    { name: "Tempo de uso (min)", data: pluck("tempoUso") }
  ];

  const hasAnyValue = series.some(s => s.data.some(v => v > 0));
  return hasAnyValue ? series : [];
}

function createTendenciaDiscreteMarkers(pointCount) {
  return Array.from({ length: pointCount }, (_, dataPointIndex) => ({
    seriesIndex: 2,
    dataPointIndex,
    size: 0
  }));
}

function createAtivosPorDiaOptions(chartHeight, tickAmount, pointCount) {
  return {
    chart: {
      type: "line",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    colors: [ATIVOS_COLORS.clientesAtivos, ATIVOS_COLORS.usuariosAtivos, ATIVOS_COLORS.tendencia],
    stroke: { curve: "monotoneCubic", width: [2.5, 2.5, 2], dashArray: [0, 0, 4] },
    markers: {
      size: 2.5,
      strokeWidth: 0,
      discrete: createTendenciaDiscreteMarkers(pointCount),
      hover: { size: 4 }
    },
    grid: {
      borderColor: "#dfe7f5",
      strokeDashArray: 4
    },
    dataLabels: { enabled: false },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      markers: { width: [12, 12, 14], height: [12, 12, 3], radius: [12, 12, 0] }
    },
    xaxis: {
      type: "datetime",
      tickAmount,
      axisBorder: { show: true },
      axisTicks: { show: true },
      crosshairs: { show: true },
      tooltip: { enabled: false },
      labels: {
        rotate: 0,
        datetimeUTC: false,
        formatter: value => formatTimestampBR(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      followCursor: false,
      x: {
        show: true,
        formatter: value => formatTimestampBR(value)
      },
      y: { formatter: value => formatInteger(value) }
    }
  };
}

function createStackedRankingOptions(chartHeight, categories, colors, onSelect) {
  return {
    chart: {
      type: "bar",
      height: chartHeight,
      stacked: true,
      parentHeightOffset: 0,
      toolbar: { show: false },
      events: {
        dataPointSelection: (event, chartContext, config) => {
          if (!onSelect) return;
          if (config.dataPointIndex < 0) return;
          onSelect(config.dataPointIndex);
        }
      }
    },
    colors,
    plotOptions: {
      bar: { horizontal: true, borderRadius: 4, barHeight: "72%" }
    },
    states: {
      active: { filter: { type: "none" } }
    },
    dataLabels: {
      enabled: true,
      formatter: value => formatInteger(value),
      style: {
        colors,
        fontSize: "12px",
        fontWeight: 600
      },
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 4,
        padding: 10,
        opacity: 0.8,
        borderWidth: 1,
        borderColor: "#d4dce8"
      }
    },
    grid: { borderColor: "#dfe7f5", strokeDashArray: 4 },
    legend: { show: true, position: "top", horizontalAlign: "center" },
    xaxis: {
      categories,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    yaxis: {
      labels: {
        maxWidth: 260,
        style: { colors: "#3d4b63", fontSize: "12px" }
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: value => formatInteger(value) }
    }
  };
}

export default {
  name: "GerencialTab",

  components: {
    ClientesFuncionalidadeDialog
  },

  props: {
    isActive: { type: Boolean, default: false },
    usoPorFuncionalidade: { type: Array, default: () => [] },
    ativosPorDia: { type: Array, default: () => [] },
    alcancePorFuncionalidade: { type: Array, default: () => [] },
    funcionalidadesMenosUtilizadas: { type: Array, default: () => [] },
    appliedFilters: { type: Object, default: () => ({}) },
    dataInicial: { type: String, default: "" },
    dataFinal: { type: String, default: "" }
  },

  data() {
    return {
      chartRefreshTick: 0,
      dialogs: {
        usoFuncionalidade: false,
        ativosPorDia: false,
        alcance: false,
        menosUtilizadas: false
      },
      clienteDialog: {
        aberto: false,
        funcionalidade: ""
      }
    };
  },

  computed: {
    usoFuncionalidadeItems() {
      const items = toArray(this.usoPorFuncionalidade);
      return sortByTotalDesc(items, [
        "acessosTela",
        "acoesRealizadas",
        "tempoUso",
        "usuariosDistintos"
      ]);
    },

    usoFuncionalidadePreviewItems() {
      return this.usoFuncionalidadeItems.slice(0, INITIAL_USO_LIMIT);
    },

    usoFuncionalidadeCategories() {
      return this.usoFuncionalidadePreviewItems.map(item => item.funcionalidade);
    },

    usoFuncionalidadeDialogCategories() {
      return this.usoFuncionalidadeItems.map(item => item.funcionalidade);
    },

    usoFuncionalidadeSeries() {
      return createUsoFuncionalidadeSeries(this.usoFuncionalidadePreviewItems);
    },

    usoFuncionalidadeDialogSeries() {
      return createUsoFuncionalidadeSeries(this.usoFuncionalidadeItems);
    },

    usoFuncionalidadeChartOptions() {
      return createUsoFuncionalidadeOptions("100%", this.usoFuncionalidadeCategories);
    },

    usoFuncionalidadeDialogOptions() {
      const options = createUsoFuncionalidadeOptions(520, this.usoFuncionalidadeDialogCategories);
      return {
        ...options,
        chart: {
          ...options.chart,
          animations: { enabled: false }
        },
        legend: {
          ...options.legend,
          position: "top",
          horizontalAlign: "left"
        },
        xaxis: {
          ...options.xaxis,
          labels: {
            ...options.xaxis.labels,
            show: true,
            rotate: -20,
            hideOverlappingLabels: false,
            showDuplicates: true,
            trim: false
          }
        }
      };
    },

    usoFuncionalidadeDialogWidth() {
      return Math.max(
        USO_DIALOG_MIN_WIDTH,
        this.usoFuncionalidadeDialogCategories.length * USO_DIALOG_ITEM_WIDTH
      );
    },

    ativosPorDiaItems() {
      const items = toArray(this.ativosPorDia);
      return comTendenciaLinear(items, "usuariosAtivos");
    },

    ativosPorDiaSeries() {
      const items = this.ativosPorDiaItems;
      if (!items.length) return [];
      const toPoints = key =>
        items.map(item => ({
          x: `${item.data}T12:00:00`,
          y: toNumber(item[key])
        }));
      return [
        { name: "Clientes", data: toPoints("clientesAtivos") },
        { name: "Usuários", data: toPoints("usuariosAtivos") },
        { name: "Tendência", data: toPoints("tendencia") }
      ];
    },

    ativosPorDiaTickAmount() {
      return Math.min(Math.max(1, this.ativosPorDiaItems.length - 1), 8);
    },

    ativosPorDiaChartOptions() {
      return createAtivosPorDiaOptions(
        "100%",
        this.ativosPorDiaTickAmount,
        this.ativosPorDiaItems.length
      );
    },

    ativosPorDiaDialogOptions() {
      return createAtivosPorDiaOptions(
        520,
        this.ativosPorDiaTickAmount,
        this.ativosPorDiaItems.length
      );
    },

    renderKey() {
      return [this.chartRefreshTick, this.dataInicial, this.dataFinal].join("|");
    },

    alcanceItems() {
      const items = toArray(this.alcancePorFuncionalidade);
      return sortByTotalDesc(items, ["clientesDistintos", "usuariosDistintos"]);
    },

    alcanceCategories() {
      return this.alcanceItems.slice(0, INITIAL_RANKING_LIMIT).map(item => item.funcionalidade);
    },

    alcanceSeries() {
      if (!this.alcanceItems.length) return [];
      return [
        {
          name: "Clientes",
          data: this.alcanceItems
            .slice(0, INITIAL_RANKING_LIMIT)
            .map(item => toNumber(item.clientesDistintos))
        },
        {
          name: "Usuários",
          data: this.alcanceItems
            .slice(0, INITIAL_RANKING_LIMIT)
            .map(item => toNumber(item.usuariosDistintos))
        }
      ];
    },

    alcanceDialogCategories() {
      return this.alcanceItems.map(item => item.funcionalidade);
    },

    alcanceDialogSeries() {
      if (!this.alcanceItems.length) return [];
      return [
        {
          name: "Clientes",
          data: this.alcanceItems.map(item => toNumber(item.clientesDistintos))
        },
        {
          name: "Usuários",
          data: this.alcanceItems.map(item => toNumber(item.usuariosDistintos))
        }
      ];
    },

    alcanceChartOptions() {
      const items = this.alcanceItems.slice(0, INITIAL_RANKING_LIMIT);
      return createStackedRankingOptions(
        "100%",
        this.alcanceCategories,
        [ALCANCE_COLORS.clientesDistintos, ALCANCE_COLORS.usuariosDistintos],
        index => this.abrirClientesDialog(items[index])
      );
    },

    alcanceDialogOptions() {
      const items = this.alcanceItems;
      return createStackedRankingOptions(
        this.rankingDialogHeight(this.alcanceItems),
        this.alcanceDialogCategories,
        [ALCANCE_COLORS.clientesDistintos, ALCANCE_COLORS.usuariosDistintos],
        index => this.abrirClientesDialog(items[index])
      );
    },

    menosUtilizadasItems() {
      const items = toArray(this.funcionalidadesMenosUtilizadas);
      return sortByTotalAsc(items, ["acessosTela", "tempoTela"]);
    },

    menosUtilizadasCategories() {
      return this.menosUtilizadasItems
        .slice(0, INITIAL_RANKING_LIMIT)
        .map(item => item.funcionalidade);
    },

    menosUtilizadasSeries() {
      if (!this.menosUtilizadasItems.length) return [];
      return [
        {
          name: "Acessos",
          data: this.menosUtilizadasItems
            .slice(0, INITIAL_RANKING_LIMIT)
            .map(item => toNumber(item.acessosTela))
        },
        {
          name: "Tempo de uso (min)",
          data: this.menosUtilizadasItems
            .slice(0, INITIAL_RANKING_LIMIT)
            .map(item => toNumber(item.tempoTela))
        }
      ];
    },

    menosUtilizadasDialogCategories() {
      return this.menosUtilizadasItems.map(item => item.funcionalidade);
    },

    menosUtilizadasDialogSeries() {
      if (!this.menosUtilizadasItems.length) return [];
      return [
        {
          name: "Acessos",
          data: this.menosUtilizadasItems.map(item => toNumber(item.acessosTela))
        },
        {
          name: "Tempo de uso (min)",
          data: this.menosUtilizadasItems.map(item => toNumber(item.tempoTela))
        }
      ];
    },

    menosUtilizadasChartOptions() {
      const items = this.menosUtilizadasItems.slice(0, INITIAL_RANKING_LIMIT);
      return createStackedRankingOptions(
        "100%",
        this.menosUtilizadasCategories,
        [MENOS_UTILIZADAS_COLORS.acessosTela, MENOS_UTILIZADAS_COLORS.tempoTela],
        index => this.abrirClientesDialog(items[index])
      );
    },

    menosUtilizadasDialogOptions() {
      const items = this.menosUtilizadasItems;
      return createStackedRankingOptions(
        this.rankingDialogHeight(this.menosUtilizadasItems),
        this.menosUtilizadasDialogCategories,
        [MENOS_UTILIZADAS_COLORS.acessosTela, MENOS_UTILIZADAS_COLORS.tempoTela],
        index => this.abrirClientesDialog(items[index])
      );
    },

    clientesDialogBody() {
      if (!this.clienteDialog.funcionalidade) return {};

      const toValues = key =>
        toArray(this.appliedFilters[key])
          .map(item => (item && item.value !== undefined ? item.value : item))
          .filter(Boolean);

      const body = {
        funcionalidade: this.clienteDialog.funcionalidade,
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal
      };

      const caracterizacoes = toValues("caracterizacao")
        .map(id => CARACTERIZACAO_SLUGS[Number(id)])
        .filter(Boolean);
      const clientes = toValues("clientes");
      const plataformas = toValues("plataformas");
      const funcionalidades = toValues("funcionalidades");

      if (caracterizacoes.length) body.caracterizacoes = caracterizacoes;
      if (clientes.length) body.clientes = clientes;
      if (plataformas.length) body.plataformas = plataformas;
      if (funcionalidades.length) body.funcionalidades = funcionalidades;

      return body;
    }
  },

  methods: {
    rankingDialogHeight(items) {
      return Math.max(RANKING_DIALOG_MIN_HEIGHT, toArray(items).length * RANKING_DIALOG_BAR_HEIGHT);
    },

    abrirClientesDialog(item) {
      if (!item || !item.funcionalidade) return;
      this.clienteDialog = { aberto: true, funcionalidade: item.funcionalidade };
    },

    refreshCharts() {
      this.chartRefreshTick += 1;
    }
  },

  watch: {
    isActive(value) {
      if (!value) return;
      this.$nextTick(() => this.refreshCharts());
    },

    usoPorFuncionalidade() {
      this.$nextTick(() => this.refreshCharts());
    },

    ativosPorDia() {
      this.$nextTick(() => this.refreshCharts());
    },

    alcancePorFuncionalidade() {
      this.$nextTick(() => this.refreshCharts());
    },

    funcionalidadesMenosUtilizadas() {
      this.$nextTick(() => this.refreshCharts());
    }
  },

  mounted() {
    if (this.isActive) {
      this.$nextTick(() => this.refreshCharts());
    }
  }
};
</script>

<style scoped>
.monitoragroweb-row {
  margin-left: -6px !important;
  margin-right: -6px !important;
}

.monitoragroweb-row > [class*="col-"] {
  padding: 6px !important;
}

.panel-card {
  border-color: #d9e2ef !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  border-radius: 18px 6px 18px 6px !important;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  height: 420px;
  max-height: 420px;
}

.panel-dialog {
  border-color: #d9e2ef !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.panel-card__header {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 16px 16px 0;
}

.panel-card__header--dialog {
  flex: 0 0 auto;
  padding: 16px;
}

.panel-card__title {
  color: #0a1f44;
  flex: 1 1 auto;
  font-size: 16px;
  font-weight: 700;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.panel-card__expand {
  flex-shrink: 0;
  height: 30px !important;
  min-width: 36px !important;
  padding: 0 8px !important;
}

.panel-card__content {
  flex: 1 1 0;
  min-height: 0;
  padding-bottom: 16px !important;
}

.panel-card__dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.panel-card__dialog-content--scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}

.panel-card__dialog-content--chart {
  overflow-x: auto;
}

.panel-card__chart-canvas {
  min-height: 520px;
}

::v-deep .monitoragroweb-dialog-content .v-dialog {
  margin: 24px auto;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
}

.panel-card__empty {
  align-items: center;
  color: #5f6b7a;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}

.monitoragroweb-action-button {
  border-color: #c7d1dc !important;
  box-shadow: none !important;
  color: #6f7d8c !important;
  font-size: 11px !important;
  font-weight: 500;
  letter-spacing: 0.01em !important;
  text-transform: none !important;
}

.monitoragroweb-action-button::before {
  background-color: transparent !important;
}

.monitoragroweb-action-button .v-icon {
  color: #748291 !important;
}

@media (max-width: 959px) {
  .panel-card {
    height: auto;
    min-height: 420px;
    max-height: none;
  }

  .panel-card__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .panel-card__title {
    white-space: normal;
  }

  .panel-card__expand {
    align-self: flex-end;
  }
}
</style>
